// 接口重试名单
export const list: Array<string> = [
    '/v2/platform/setting',
    '/user/create'
];
